import {AbstractDownloadActionService} from '../../../../core/service/v2/service/download/abstractDownloadAction.service';
import {CustomizeHttpUrlGenerator} from '../../../../../store/core/url/customizeHttpUrlGenerator';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {PayloadWithId} from '../../../../core/service/payload/payloadWithId';

@Injectable()
export class DocumentDownloadService extends AbstractDownloadActionService<PayloadWithId> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('Document', 'download', customizeHttpUrlGenerator, httpClient);
    }
}
